// extracted by extract-css-chunks-webpack-plugin
module.exports = {"SocialShare":"SocialShare","SocialShare__items":"SocialShare__items","SocialShare__items--first":"SocialShare__items--first"};